import Param from '../../param';
import effectManager from '../effect';

const param = new Param();
let effect;

/* ---------------------------------------

    -- ページナビゲーション

--------------------------------------- */
export default class Pager{
    constructor(inc){

        effect = new effectManager();

        this.$target = $(".js__sc-point");
        this.$contanter = $('#l-pager');
        this.$list = $('#l-pager-list >li');

        this.$bg = $("#svg-pager-bg-base");

        this.point = [];
        this.prevPoint = 0;/* 一つ手前にある要素のoffset保存 */

        this.current = 0;
        this.prevCurrent = 0;

        this.status = {
            pager : "def",
            hover : false,
            bg    : "def",
            modal : "" // SPのモーダルの状態 close || open
        }

        /* ページャーをスマホではモーダルタイプで仕様 */

        this.mode = "pc"; // pc : 追従　| sp : モーダル

        this.$modalBody = $("#l-pager");
        this.$modalTrigger = $("#l-pager-trigger");
        this.$modalContents = $("#l-pager-list >li,#l-pager-shareon");
        this.$modalSvg =  $("#l-pager-circle");

        this.modalTimer;

    }
    init(){

        let _this = this;

        let _timer;

        /* --------------------------------------------------

            --  [ モーダルの開閉動作 SP用 ]

        * -------------------------------------------------- */

        _this.$modalTrigger.on("click",function(){

            let _mode = ($(this).hasClass("is-close"))? "close" : "open";

            _this.spModal($(this),_mode);

        });

        /* ページ内遷移する際はとりあえず閉じる */
        this.$list.on("click",function(){
            if( window.innerWidth <= param.breakpoint ) _this.spModal(_this.$modalTrigger,"close");
        });

        /* --------------------------------------------------

            --  [ 追従時のhover動作 ]

        * -------------------------------------------------- */

        _this.$list.on("mouseenter",function(){

            if(_this.mode !== "pc") return;

            clearTimeout(_timer);

            if(_this.status.pager == "def"||_this.status.bg!=="def") return;
            _this.status.hover = true;
            _this.$contanter.addClass("is-hover");

            _this.motion("mouseon");

        }).on("mouseleave",function(){

            if(_this.mode !== "pc") return;

            _timer = setTimeout(function(){
                if(_this.status.pager == "def"||!_this.status.hover) return;

                _this.motion("mouseout");

            },1e2);



        });

    }
    update(inc,dir,winH){



        // if(this.mode !== "pc") return;

        for(let i=0; this.point.length>=i; i++){

                if(dir==="next"){
                    if(this.point[i]<inc+winH/1.5){
                        if(this.current<i+1) this.current = i+1;
                    }
                }else{

                    if(this.point[i]-winH/1.5>inc){
                        if(this.current-1===i) this.current = i;
                    }
                }

                if(this.prevPoint!=this.current){
                    this.prevPoint=this.current;

                    this.$list.removeClass("is-current");
                    this.$list.eq(this.current).addClass("is-current");

                    if(this.mode !== "pc") return;

                    if(this.current===0){

                        if(!this.$contanter.hasClass("is-show")) return;

                        this.motion("def");

                    }else{

                        if(this.$contanter.hasClass("is-show")) return;

                        this.motion("active");


                    }

                }

        }

    }

    spModal($trigger,mode){

        let _this = this;

        if(mode === "open"){

            clearTimeout(this.modalTimer);
            TweenMax.set(this.$modalBody,{"display":"block"});

            $trigger.addClass("is-close");

            this.motion("mouseon");
            effect.show(this.$modalContents,"show");
            effect.svgAnimation(this.$modalSvg,0.4);

        }else{

            $trigger.removeClass("is-close");
            this.motion("def");
            effect.show(this.$modalContents,"out");
            effect.svgAnimationOut(this.$modalSvg,0.05);

            this.modalTimer = setTimeout(function(){
                TweenMax.set(_this.$modalBody,{"display":"none"});
            },1e3);

        }

    }
    motion(type){ //タイプは4パターン def || active || mouseon || mouseout


        switch(type){
            case "def" :
                this.status.pager = "def";
                this.$contanter.removeClass("is-show");

                TweenMax.to(this.$bg,0.48,{
                    morphSVG : this.$bg
                });

                break;
            case "active":

                this.status.pager = "active";
                this.$contanter.addClass("is-show");

                TweenMax.to(this.$bg,1.88,{
                    morphSVG : "#svg-pager-bg-show",
                    ease: Elastic.easeOut.config(1, 0.3)
                });

                break;

            case "mouseon":

                this.status.bg = "show";
                TweenMax.to(this.$bg,1.88,{
                    morphSVG : "#svg-pager-bg-hover",
                    ease: Elastic.easeOut.config(1, 0.75),
                    onComplete:function(){
                    }
                });

                break;
            case "mouseout":

                this.status.bg = "def";
                this.status.hover = false;
                this.$contanter.removeClass("is-hover");
                TweenMax.to(this.$bg,0.88,{
                    morphSVG : "#svg-pager-bg-show",
                    ease: Elastic.easeOut.config(1, 0.4),
                    onComplete:function(){

                    }
                });

                break;
        }


    }

    resize (display) {

        for(let i=0; i<this.$target.length; i++){
            this.point[i] = this.$target.eq(i).offset().top;
        }


        this.mode = display;

        if(display==="sp"){
            if(this.status.modal!=="close"){
                this.status.modal = "close";
                effect.show(this.$modalContents,"set");
                this.motion("def");
                let _this = this;
                this.modalTimer = setTimeout(function(){
                    TweenMax.set(_this.$modalBody,{"display":"none"});
                },3e2);
            }
        }else{
            if(this.status.modal!=="open"){
                clearTimeout(this.modalTimer);
                this.status.modal = "open";
                TweenMax.set(this.$modalBody,{"display":"block"});
                this.$modalTrigger.removeClass("is-close");
                this.$modalContents.attr("style","");
                // this.$modalSvg.find(".js__write").attr("style","");
                effect.svgAnimationOut(this.$modalSvg,0);

                if(this.current===0){
                    this.motion("def");
                }else{
                    this.motion("active");
                }

            }

        }

    }
}